export default {
  setProperty(state, { payload, property }) {
    state[property] = payload;
  },

  setUpdatedCountry(state, { countryId, country }) {
    state.countries.data.map((item) => {
      if (item.id === countryId) {
        return { ...item, ...country };
      }
    });
  },
};
